// Splash.tsx — premium launch overlay: the wordmark on a calm cream field, gently
// risen in, held briefly, then softly faded out. Self-contained and timer-driven;
// it unmounts itself so it never blocks interaction. Mounted as a sibling of <App/>
// so it covers the first paint regardless of which screen the app boots into.
import React from 'react';
import { Wordmark } from '@/components/icons';

export function Splash() {
  const [phase, setPhase] = React.useState<'in' | 'out' | 'gone'>('in');
  React.useEffect(() => {
    const hold = setTimeout(() => setPhase('out'), 1100); // gentle hold
    const done = setTimeout(() => setPhase('gone'), 1850); // after the fade completes
    return () => { clearTimeout(hold); clearTimeout(done); };
  }, []);

  if (phase === 'gone') return null;
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: 'var(--cream, #f7f1e6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: phase === 'out' ? 0 : 1,
        transition: 'opacity .72s cubic-bezier(.4,0,.2,1)',
        pointerEvents: phase === 'out' ? 'none' : 'auto',
      }}
    >
      <style>{`@keyframes splashRise{0%{opacity:0;transform:translateY(7px) scale(.985)}100%{opacity:1;transform:none}}`}</style>
      <div style={{ animation: 'splashRise 1.05s cubic-bezier(.2,.7,.3,1) both' }}>
        <Wordmark h={36} />
      </div>
    </div>
  );
}
